import { message } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { useAsyncFn } from 'react-use';
import shallow from 'zustand/shallow';

import { useAuthStore } from '../../stores';
import { FormPageProps, LocationState } from '../../typings';
import { getDefaultLocationState } from '../../utils';
import { CardPage } from '../components/CardPage';
import { CONFIRM_ROUTE } from '../routes';

import { LoginFrom } from './components';

export function Login({ defaultPath }: FormPageProps) {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation<LocationState>();
  const { isAuthenticated, login } = useAuthStore(
    ({ isAuthenticated, login }) => ({ isAuthenticated, login }),
    shallow
  );

  const loginSubmit = React.useCallback(
    async (values) => {
      const { email, password } = values;

      try {
        await login(email, password);
      } catch (error) {
        if (error.code === 'UserNotConfirmedException') {
          message.info(t('ACCOUNT_NOT_CONFIRMED'));
          history.push({ pathname: CONFIRM_ROUTE, search: `email=${encodeURIComponent(email)}` });

          return;
        }

        console.log('Login -> error', error);
        message.error(error.message);
      }
    },
    [history, login, t]
  );

  const [{ loading }, handleLoginSubmit] = useAsyncFn(loginSubmit);

  const { from } = location.state ?? getDefaultLocationState(defaultPath);

  if (isAuthenticated) return <Redirect to={from.pathname} />;

  return (
    <CardPage title={t('LOGIN_PAGE_TITLE')}>
      <LoginFrom onFinish={handleLoginSubmit} loading={loading} />
    </CardPage>
  );
}
